export default __webpack_public_path__ + "static/media/robotImg.bfc82d2a.png";